module.exports = __webpack_public_path__ + "static/media/sasmanager.1a7952aa.svg";